import Appoinments from './Appointment/Appoinments';
import AppHeadNave from './AppHeadNave';
import AppCalander from './Calander/AppCalander';
import AppSummary from './Summary/AppSummary';
import AppToDo from './Todo/AppToDo';
import { useEffect, useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import OpenNoteAlertPopup from '../OpenNoteAlertPopup';
import AppTask from './AppTask';
import { useDispatch, useSelector } from 'react-redux';
import { defSchedTab } from '../../redux/slices/appSlice';

function Scheduler() {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { defaultSchedulerTab } = useSelector((store) => store.app);

  const [allData, setAllData] = useState([]);
  const [notePopup, setNotePopup] = useState(false);

  const handleShedulTab = (tab) => {
    dispatch(defSchedTab(tab));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/openNoteAlertPopup',
          { remType: 0, remDays: 9, loginUserId: user?.id }
        );
        if (response.status === 200) {
          if (response.data?.countStatus !== 'fail') {
            setAllData(response.data);
            setNotePopup(true);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    };
    fetchData();
  }, [user?.id]);

  return (
    <>
      <AppHeadNave setShedulTab={handleShedulTab} />
      {(() => {
        if (defaultSchedulerTab === 'app') {
          return <Appoinments />;
        } else if (defaultSchedulerTab === 'aptOpen') {
          return <Appoinments tabType={'1'} />;
        } else if (defaultSchedulerTab === 'aptClose') {
          return <Appoinments tabType={'2'} />;
        } else if (defaultSchedulerTab === 'cal') {
          return <AppCalander />;
        } else if (defaultSchedulerTab === 'sumry') {
          return <AppSummary />;
        } else if (defaultSchedulerTab === 'todo') {
          return <AppToDo />;
        } else if (defaultSchedulerTab === 'task') {
          return <AppTask />;
        }
      })()}
      {notePopup && (
        <OpenNoteAlertPopup cloase={() => setNotePopup(false)} data={allData} />
      )}
    </>
  );
}

export default Scheduler;
